import {setMockDateTilJavaNå} from '../test/mocks/mockDate';
import {Debugger} from 'debug'
import moment from "moment";
import _ from "lodash";
import {v4} from "uuid";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {aktiverDebuggLogging} from "felles-ng2/støttefunksjoner/debug";

const debuger = require('debug');
const debug:Debugger = debuger('Konfigurasjon');

export enum Miljø {
    enhetstest = 'enhetstest',
    test = 'test',
    e2etest = 'e2etest',
    testhttps = 'testhttps',
    branch = 'branch',
    // preprod er satt opp som preprod miljø i azure - denne må matche stack preprod når vi deployer styreplan til azure.
    preprod = 'preprod',
    // testmiljo er satt opp som testmiljø i azure - - denne må matche stack testmiljo når vi deployer styreplan til azure.
    testmiljo = 'testmiljo',
    prod = 'prod',
    larstest = 'larstest'
}

export class Konfigurasjon {

    static regNavn = 'konfigurasjon';

    /** Finner ut av hvilket miljø vi kjører i. */
    static avgjørForespurtMiljø(location: Location): Miljø {
        /* les fra window.lederplanMiljoe - brukt i testsammenheng (karmatester) - se standardFellesModulerForTester.ts*/
        if (window['lederplanMiljoe']) {
            debug('Leser ønsket konfigurasjonsmiljø fra window.lederplanMiljoe');
            return window['lederplanMiljoe'];
        }

        /* les fra localStorage.lederplan.lederplanMiljoe - brukt i testsammenheng (e2e-tester) - se nettleser.NettleserFabrikk.standardStorage i lederplan-e2etesterplaywright */
        try {
            const miljø = <Miljø> localStorage.getItem('lederplan.lederplanMiljoe');
            if (miljø) {
                debug('Leser ønsket konfigurasjonsmiljø fra localStorage.lederplan.lederplanMiljoe');
                return miljø;
            }
        } catch (e){}

        const miljøangivelse = location.search.match(/miljoe=(\w+)/);
        if (miljøangivelse !== null) return <Miljø> miljøangivelse[1];

        // ved kjøring av app i android/ios bruker vi prod-konfigurasjonen -
        // lederplan-app/build.gradle#settApiAdresseTilUtviklermaskinIKlientkode kalt ved forberedEmuleringIos/forberedEmuleringAndroid
        // vil endre 'https://app.styreplan.no' i konfigurasjon.serviceRotUrl for prod til ip til utviklermaskin
        if(window['cordova'] != null) return Miljø.prod;

        if ((_.startsWith(location.host, '127.0.0.1') || _.startsWith(location.host, 'localhost') || _.startsWith(location.host, '10.0.') || _.startsWith(location.host, '192.') || _.startsWith(location.host, 'dolly.systemfabrikken.org'))
            && !_.includes(location.search, 'e2e')) return Miljø.test;

        if (location.host.match(/^app\.styreplan\.local/) !== null) return Miljø.testhttps;

        if (location.host.match(/^lederplan-.*\.systemfabrikken\.org$/) !== null) return Miljø.branch;
        if (location.host.match(/^preprod\.styreplan\.no$/) !== null) return Miljø.preprod; // NB url må match den som er konfigurert i stack preprod når vi deployer med pulumi
        if (location.host.match(/^testmiljo\.styreplan\.azure\.systemfabrikken\.org$/) !== null) return Miljø.testmiljo; // NB url må match den som er konfigurert i stack testmiljo når vi deployer med pulumi
        if (location.host.match(/^.*\.styreplan\.azure\.systemfabrikken\.org$/) !== null) return Miljø.branch;

        return Miljø.prod;
    }

    static lastKonfigurasjonForMiljø(miljø: Miljø): Konfigurasjon {
        const konfigurasjon = new Konfigurasjon();
        konfigurasjon.miljø = miljø;
        switch (miljø) {

            case Miljø.e2etest:
                konfigurasjon.serviceOverHttps = false;
                konfigurasjon.serviceRotUrl = '';
                konfigurasjon.cookieDomene = '';
                konfigurasjon.wkMenyHoverTriggerAktivert = false; //fordi vi opplever ustabile tester når vi åpner/lukker meny vhja mus in/ut - virker som om musen av og til flytter seg ut av menyen
                konfigurasjon.appSkalKontrollerePin = false; // For å unngå at alle tester må ha et forhold til dette
                konfigurasjon.appMaksInaktivitetFørPinkodekrav = moment.duration(2, 'seconds'); // Kan ved behov lages konfigurerbart via verdi i local storage og ScenarioKontekst, se lederplan.e2e.pinkontrollAktivert
                aktiverDebuggLogging(); //aktiverer debug    til konsole via require('debug')
                //ved kjøring av phantom-tester må vi sette en fast dato
                setMockDateTilJavaNå();
                break;

            case Miljø.enhetstest:
                konfigurasjon.serviceOverHttps = false;
                konfigurasjon.serviceRotUrl = '';
                konfigurasjon.cookieDomene = '';
                konfigurasjon.appSkalKontrollerePin = false; // For å unngå at alle tester må ha et forhold til dette
                konfigurasjon.maksFilstørrelse = 1024 * 1024 * 10;
                //ved kjøring av phantom-tester må vi sette en fast dato
                setMockDateTilJavaNå();
                break;

            case Miljø.test:
                konfigurasjon.serviceOverHttps = false;
                konfigurasjon.serviceRotUrl = '';
                konfigurasjon.cookieDomene = '';
                //i test eksponerer vi mer enn i produksjon, deriblandt norsk_bankid_mobil_tekst for å kunne test indirekte sign uten bruk av bankidmobil som vi ikke får testet i bankid preprod
                konfigurasjon.tilgjengeligeSigneringsmetoderAvansertElektronisk = [
                    l.Signeringsmetode.norsk_bankid_netsentrisk_pdf,
                    l.Signeringsmetode.norsk_bankid_netsentrisk_tekst,
                    l.Signeringsmetode.svensk_bankid_samedevice,
                    l.Signeringsmetode.svensk_bankid_anotherdevice,
                    l.Signeringsmetode.svensk_bankid_anotherdeviceqr];
                aktiverDebuggLogging(); //aktiverer debug til konsole via require('debug')
                //ved kjøring av phantom-tester må vi sette en fast dato
                setMockDateTilJavaNå();
                break;

            case Miljø.testhttps:
                konfigurasjon.serviceOverHttps = true;
                konfigurasjon.serviceRotUrl = '';
                konfigurasjon.cookieDomene = '';
                aktiverDebuggLogging(); //aktiverer debug til konsole via require('debug')
                //ved kjøring av phantom-tester må vi sette en fast dato
                setMockDateTilJavaNå();
                break;

            case Miljø.larstest:
                konfigurasjon.serviceOverHttps = false;
                konfigurasjon.serviceRotUrl = '';
                konfigurasjon.cookieDomene = '';
                aktiverDebuggLogging(); //aktiverer debug til konsole via require('debug')
                //ved kjøring av phantom-tester må vi sette en fast dato
                // setMockDateTilJavaNå();
                break;


            case Miljø.branch:
                konfigurasjon.serviceOverHttps = true;
                konfigurasjon.serviceRotUrl = 'https://@branchdomene@'; //settes til korrekt verdi via filtrerServiceRotUrl gradletask i lederplan-tjenester-branch
                konfigurasjon.cookieDomene = '@branchdomene@'; //settes til korrekt verdi via filtrerServiceRotUrl gradletask i lederplan-tjenester-branch
                break;

            case Miljø.testmiljo:
                konfigurasjon.serviceOverHttps = true;
                konfigurasjon.serviceRotUrl = 'https://testmiljo.styreplan.azure.systemfabrikken.org';
                konfigurasjon.cookieDomene = 'testmiljo.styreplan.azure.systemfabrikken.org';
                break;

            case Miljø.preprod:
                konfigurasjon.serviceOverHttps = true;
                konfigurasjon.serviceRotUrl = 'https://preprod.styreplan.no';
                konfigurasjon.cookieDomene = 'preprod.styreplan.no';
                break;

            case Miljø.prod:
                konfigurasjon.serviceOverHttps = true;
                konfigurasjon.serviceRotUrl = 'https://app.styreplan.no';
                konfigurasjon.cookieDomene = 'app.styreplan.no';
                break;

            default:
                throw 'ukjent konfigurasjonsnavn :' + miljø;
        }
        debug('lastet konfigurasjon for miljø %s, %O', miljø, konfigurasjon.somStrengForLogging());
        return konfigurasjon;
    }

    /** Navn på lastet konfigurasjon (test/e2etest/preprod/prod) */
    miljø: Miljø;
    /** Hvilken klient vi kjører i (mobil/web) - blir satt i mobilModul.ts / webModul.ts */
    klientType: 'web' | 'mobil';
    /** rot-url til api-endepunktet */
    serviceRotUrl: string;
    /** domenet cookies skal lagres under ved setting av cookies vhja javascript */
    cookieDomene: string;
    /** angir hvorvidt vi forventer at tjenestekall skal skjer over https eller ei */
    serviceOverHttps: boolean;

    /** Angir hvor lenge før token utløpstid vi skal fornye token av typen {@link l.Tokenvarighet.kort}.
     * @see Autentisering#startAutomatiskKortTokenfornyelse() */
    kortTokenFornymargin = moment.duration(2, 'minutes');
      /** maks inaktivitet før advarsel om utlogging vises, ved token av typen {@link l.Tokenvarighet.kort}
     * @see Utlogging#startLoggUtEtterInaktivitetTimer() */
    maksInaktivitetFørVarsel = moment.duration(45, 'minutes');
    /** hvor lenge advarsel om utlogging vises før bruker logges ut, ved token av typen {@link l.Tokenvarighet.kort}
     * @see Utlogging#visUtloggingsvarsel() */
    inaktivitetVarselTimeout = moment.duration(14, 'minutes');
    /** Angir hvor lenge etter innlogging med kort token infomelding om oppgradering av token skal vises.
     * @see MeldingTilBrukerVedInnlogging#visForsinketOppgraderSesjonMelding() */
    kortTokenOppgraderVarselForsinkelse = moment.duration(2, 'seconds');

    /** Angir hvor lenge før token utløpstid vi skal logge ut bruker ved token av typen {@link l.Tokenvarighet.medium} ved navigasjon.
     * @see Autentisering#reautentiserDersomTokenUtløperSnart() */
    mediumTokenLoggutmarginVedNavigasjon = moment.duration(60, 'minutes');

    /** Angir hvor lenge før token utløpstid vi skal logge ut bruker ved token av typen {@link l.Tokenvarighet.medium} ved autentisering.
     * @see Autentisering#reautentiserDersomTokenUtløperSnart() */
    mediumTokenLoggutmarginVedAutentisering = moment.duration(1, 'days');

    /** Angir hvor lenge før token utløpstid vi skal fornye token av typen {@link l.Tokenvarighet.lang}.
     * @see Autentisering#fornyLangTokenDersomUtløperSnart() */
    langTokenFornymargin = moment.duration(30, 'days');

    /** Hvorvidt wk-meny komponenten åpner/skjuler meny ved mus over / mus ut event (gjort konfigurerbar da vi må deaktivere mus in/ut triggere ved e2e tester)*/
    wkMenyHoverTriggerAktivert = true;

    /** ID til appen tilgjengelig i appstore */
    apple_itunes_app_id = '967267969';

    /** ID til appen tilgjengelig i google play */
    google_play_app_id = 'no.systemfabrikken.lederplan';

    /** Privacy policy for appen, som må lenkes til iht. https://support.google.com/googleplay/android-developer/answer/15225428?#:~:text=Data%20safety%20section.-,Privacy%20Policy,and%20a%20privacy%20policy%20link%20or%20text%C2%A0within%20the%20app%20itself.,-The%20privacy%20policy */
    appPrivacyPolicyURL = 'https://www.styreplan.no/personvern-i-styreplan-app'

    /** Antall forsøk brukeren får på å skrive inn riktig pin */
    appAntallForsøkPinkode = 5;

    /** Hvor lenge brukeren kan være inaktiv i appen før vi krever pin-kode på nytt */
    appMaksInaktivitetFørPinkodekrav = moment.duration(10, 'minutes');

    /** Hvor lenge appen kan ha vært i bakgrunnen før den "resumes" og brukeren må gi pin på nytt */
    appMaksTidIBakgrunnFørPinkodekrav = moment.duration(2, 'minutes');

    /** Om app skal kreve kontroll av pin-kode */
    appSkalKontrollerePin = true;

    /** Identifiserer denne klienten (nettleser-arkfanen feks) og gjør det feks mulig å identifisere hvorvidt en modelloppdatering-pushmelding stammer fra denne klienten. */
    klientId = v4();

    /** Maks størrelse på avatar/gruppe logo ved opplasting. Må holdes i synk med java-siden no.systemfabrikken.lederplan.LederplanKonfigurasjon.MAKS_BASE64_AVATAR_STØRRELSE */
    maksAvatarStørrelse = 1024 * 1024 * 5; // 5Mb

    /**
     * Maks størrelse på fil ved opplasting til arkiv/sak, må være mindre eller like nginx størrelse , se client_max_body_size i (docker prosjektet) images/ops/nginx-prod/docker/filer/nginx/conf.d/includes/styreplan3.nginx
     * må være lik OpplastetDokumentVersjon#MAKS_DOKUMENTSTØRRELSE
     */
    maksFilstørrelse: number = 1024 * 1024 * 150; // 150Mb

    /**
     * må være mindre eller like nginx størrelse , se client_max_body_size i (docker prosjektet) images/ops/nginx-prod/docker/filer/nginx/conf.d/includes/styreplan3.nginx
     * må være lik ArkivImportFraZip#maksZipFilstørrelseIBytes
     */
    maksFilstørrelseArkivImport: number = 1024 * 1024 * 1024; // 1GiB


    /** signeringsmetoder av typen "avansert elektronisk" tilgjengelig for bruker ved signering av dokument */
    tilgjengeligeSigneringsmetoderAvansertElektronisk = [
        l.Signeringsmetode.norsk_bankid_netsentrisk_pdf,
        l.Signeringsmetode.svensk_bankid_samedevice,
        l.Signeringsmetode.svensk_bankid_anotherdevice,
        l.Signeringsmetode.svensk_bankid_anotherdeviceqr];

    klientTypeErWeb(): boolean {
        return this.klientType == 'web';
    }

    klientTypeErMobil(): boolean {
        return this.klientType == 'mobil';
    }

    somStrengForLogging(){
        return {...this,
            kortTokenFornymargin:this.kortTokenFornymargin.toString(),
            maksInaktivitetFørVarsel:this.maksInaktivitetFørVarsel.toString(),
            inaktivitetVarselTimeout:this.inaktivitetVarselTimeout.toString(),
            kortTokenOppgraderVarselForsinkelse:this.kortTokenOppgraderVarselForsinkelse.toString(),
            mediumTokenLoggutmarginVedNavigasjon:this.mediumTokenLoggutmarginVedNavigasjon.toString(),
            mediumTokenLoggutmarginVedAutentisering:this.mediumTokenLoggutmarginVedAutentisering.toString(),
            langTokenFornymargin:this.langTokenFornymargin.toString()
        }
    }
}
